import * as React from "react";

export default () => {
  return <h1 className="font-bold text-6xl text-center">Coming soon!</h1>;
};
